<template>
  <div class="page page-inner">
    <breadcrumb title="Time Recording Request"></breadcrumb>
    <div class="card card-fluid">
      <!-- .card-header -->
      <div class="card-header nav-scroller">
        <!-- .nav-tabs -->
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a href="#" class="nav-link active" @click.prevent="setActive('time-recording-request')" data-toggle="tab">Time Recording
              Request</a>
          </li>
        </ul>
        <!-- /.nav-tabs -->
      </div>

      <div class="card-body">
        <div class="tab-content py-3" id="myTabContent">
          <div class="tab-pane fade" :class="{ 'active show': isActive('time-recording-request') }" id="home">
            <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                </div>
                <div class="col-sm-12 col-md-6">
                  <div  class="dataTables_filter">
                    <label>
                      Search:<input type="search" class="form-control" placeholder="" aria-controls="data-table-time-recording-request">
                    </label>
                  </div>
                </div>
              </div>

              <b-table hover :items="items" :fields="fields" :sticky-header="stickyHeader"
                       :no-border-collapse="noCollapse" :sort-direction="sortDirection" :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc" responsive
                       table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" class="table-height" hover
                       :class="{'hide-scroll': isScrollHide()}">

                <template v-slot:cell(action)="row">
                  <a class="btn btn-xs" @click="approvalForm(row.item, row.index, $event.target)" title="Approve" v-if="row.item.stat_id == 1">
                    <em class="fas fa-sign-in-alt"></em>
                  </a>
                </template>
              </b-table>
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_info" id="data-table-leave-request-request_info" role="status"
                       aria-live="polite">Showing {{ currentPage }} to {{ perPage }} of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                  <div class="dataTables_paginate paging_simple_numbers">
                    <b-pagination v-model="currentPage" v-on:click="getData" :per-page="perPage" :total-rows="rows"
                                  :align="right"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

import {mapGetters} from "vuex";
import {BButton, BPagination, BTable} from "bootstrap-vue"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "ListTimeRecording",
  components:{
    Breadcrumb, BButton, BPagination, BTable
  },
  data(){
    return {
      activeItem: "time-recording-request",
      noCollapse: false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items: [],
      fields: [
        {key: 'no', sortable: true, thStyle: {maxWidth: '60px', minWidth: '10px'}},
        {key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'}},
        {key: 'request_date', label: 'Request Date', sortable: true},
        {key: 'emp_name', label: 'Employee', sortable: true},
        {key: 'period', label: 'Period', sortable: true},
      ],
      rows: 0,
      perPage: 20,
      currentPage: 1,
      right: "right",
    }
  },
  computed: {
    ...mapGetters(['scrollbarHide']),
  },
  watch:{
    currentPage(){
      this.getData()
    }
  },
  methods:{
    isScrollHide() {
      return this.scrollbarHide
    },
    setActive(itemTabs) {
      this.activeItem = itemTabs
      this.getData()
    },
    isActive(itemTabs) {
      return this.activeItem === itemTabs
    },
    getData() {
      this.items = []
      let payload = {
        page:this.currentPage,
        limit:this.perPage,
      }

      AxiosCall.Get(payload, urlApi.time_recording.list_request).then(res=>{
        if(res.success){
          let no = (this.currentPage - 1) * this.perPage +1
          for(let data of res.atributes){
            data.no = no++
            this.items.push(data)
          }
          this.rows = res.total
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    toInput() {
      this.$router.push({path: "travel-request-input"})
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    resetModal(){
      this.data = null
    },
    approvalForm(items){
      this.$router.push({name:"TimeRecordingApproval", query:{emp_id:btoa(items.emp_id.toString()), period:btoa(items.period.toString())}})
    }
  },
  created() {
    this.getData()
  }
}
</script>